import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

// If the current URL was launched from the kiosk (`?from=kiosk&kc=<code>`),
// return to the kiosk home after `timeoutMs` of no user activity so a
// walked-away guest doesn't strand the tablet in the middle of a form.
// Any keypress, tap, mouse move, or scroll resets the timer.
export function useKioskIdleReturn(timeoutMs = 90_000) {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const timerRef = useRef(null);

  useEffect(() => {
    const fromKiosk = params.get("from") === "kiosk";
    const kioskCode = params.get("kc");
    if (!fromKiosk || !kioskCode) return;

    const goHome = () => navigate(`/kiosk/${kioskCode}`, { replace: true });
    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(goHome, timeoutMs);
    };

    const events = ["mousedown", "touchstart", "keydown", "mousemove", "scroll"];
    events.forEach((ev) => window.addEventListener(ev, reset, { passive: true }));
    reset(); // arm on mount

    return () => {
      events.forEach((ev) => window.removeEventListener(ev, reset));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [params, navigate, timeoutMs]);
}
